import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AirportSearchService } from '../../service/airport-search.service';
import { ApiRequest,
  Filter, FilterComposit,
  FilterPredicate, Sort, SortCondition,
  PageInfo, ApiResponse } from '../../model/api-request';
import { Airport } from '../../model/airport';
import { CurrentAptService } from 'src/app/service/current-apt.service';


@Component({
  selector: 'app-airport-search',
  templateUrl: './airport-search.component.html',
  styleUrls: ['./airport-search.component.css']
})
export class AirportSearchComponent implements OnInit {
  public pageTitle = 'AirportSearch';
  public apiRequest: ApiRequest;
  public apiResponse: ApiResponse;
  showLoading: boolean = false;
  airportIsDisabled: boolean = false;
  cityIsDisabled: boolean = false;


  airport: string;
  airportCity: string;
  errorMessage: string;

  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('advancedSearchInput') advancedSearchInput: ElementRef;
  @ViewChild('searchInput2') searchInput2: ElementRef;
  @ViewChild('advancedSearchInput2') advancedSearchInput2: ElementRef;


  private selectedLink = '(LocationIdentifierOnly)';


  // tslint:disable-next-line: max-line-length
  constructor(private airportSearchService: AirportSearchService,
    private router: Router,
    private data: CurrentAptService) {
  }   // constructor used mostly for dependency Injection

  ngOnInit() {
    this.airport = '';
    this.airportCity = '';
  }

  onSearch() {
    this.apiRequest = new ApiRequest();

    let filterPredicate1: Array<FilterPredicate>;
    let filterPredicate2: Array<FilterPredicate>;
    let filterPredicate3: Array<FilterPredicate>;
    let filterCompositArray: Array<FilterComposit>;
    let sortConditionArray: Array<SortCondition>;

    if (this.airport.length > 0) {
      filterPredicate1 = [new FilterPredicate('AirportIdentifier', 'String', this.airport, 'IsEqualTo')];
      filterCompositArray = [new FilterComposit(filterPredicate1, 'Or')];
      this.apiRequest.filter = new Filter(filterCompositArray, 'And');
    } else if (this.airportCity.length > 0) {
      filterPredicate1 = [new FilterPredicate('AssociatedCity', 'String', this.airportCity, 'Contains')];
      filterPredicate2 = [new FilterPredicate('AirportName', 'String', this.airportCity, 'Contains')];
      filterPredicate3 = [new FilterPredicate('StateCode', 'String', this.airportCity, 'Contains')];

      filterCompositArray = [
        new FilterComposit(filterPredicate1, 'Or'),
        new FilterComposit(filterPredicate2, 'Or'),
        new FilterComposit(filterPredicate3, 'Or')];
      this.apiRequest.filter = new Filter(filterCompositArray, 'Or');

    } else {
      this.errorMessage = 'Please enter at least one criteria.';
    }

    if (this.airport.length > 0 || this.airportCity.length > 0) {
      sortConditionArray = [new SortCondition('airportIdentifier', 'Ascending')];
      this.apiRequest.sort = new Sort(sortConditionArray);

      this.apiRequest.pageInfo = new PageInfo(0, 1, 5);  // SQL 2008 requires 0, 0, 0

      console.log(this.apiRequest);

      this.airportSearchService.getMultiple(this.apiRequest).subscribe((result => {
        if (result.status === 500) {
          this.errorMessage = 'Airport Not Found Please enter a valid Search Criteria';
          return;
        }

        let airportSearchResults: Airport[];
        airportSearchResults = result.data as Airport[];

        console.log('step1');

        if (airportSearchResults.length > 1) {
          console.log('step3');
          this.data.setCurrentCity(this.airportCity);
          this.router.navigate(['\gridview']);

        } else {
          console.log('step4');
          // Set Current Airport - Only one Airport Found
          this.data.setCurrentAirport(airportSearchResults[0].airportIdentifier);
          this.router.navigate(['\dashboard']);
        }

        console.log('step2');

      }));
    }



  }


  onAdvancedSearch() {
    this.router.navigate(['\advancedSearch']);
  }
  onReset(){
    this.airportIsDisabled=false;
    this.cityIsDisabled=false;
    this.searchInput.nativeElement.value='';
    this.advancedSearchInput.nativeElement.value='';
    this.searchInput2.nativeElement.value='';
    this.advancedSearchInput2.nativeElement.value='';
    this.errorMessage=null;
    this.airport = '';
    this.airportCity = '';
  }
  airportKeyUp(){

    this.cityIsDisabled = true;
    if (this.airport.length == 0 && this.airportCity.length == 0){
      this.cityIsDisabled = false;
      this.airportIsDisabled = false;
    }
  }

  cityKeyUp(){
    this.airportIsDisabled = true;
    if (this.airport.length == 0 && this.airportCity.length == 0){
      this.cityIsDisabled = false;
      this.airportIsDisabled = false;
    }
  }

  public isSelected(name: string): boolean {
    if(!this.selectedLink) {
      return false;
    }
    return (this.selectedLink === name);
  }

}
